import type { MailSignature } from '@/api'

/** The signature a mailbox's next mail carries, and whether it is the enterprise's template filled in for the mailbox. */
export type SignatureInUse = { html: string; text: string; fromTemplate: boolean }

/** Whether a signature says anything at all: some text, or some HTML (an image alone). */
export function hasWords(signature: { html: string; text: string } | null | undefined): boolean {
    return Boolean(signature && (signature.html.trim() !== '' || signature.text.trim() !== ''))
}

/**
 * Which signature the OS adds to a mailbox's mail, as the API decides it (#1118): the mailbox's own when it has one;
 * else the enterprise's template, filled in for the mailbox, unless the mailbox switched it off; else none (null).
 */
export function signatureInUse(signature: MailSignature | null | undefined): SignatureInUse | null {
    if (!signature) {
        return null
    }
    if (hasWords(signature)) {
        return { html: signature.html, text: signature.text, fromTemplate: false }
    }
    if (signature.useTemplate !== false && signature.template && hasWords(signature.template)) {
        return { html: signature.template.html, text: signature.template.text, fromTemplate: true }
    }
    return null
}
